import Handsontable from 'handsontable';

export default function isLastRowOfEntry(visualRow: number, instance: Handsontable) {
  const rowId = instance.getDataAtRowProp(visualRow, 'id');
  const nextRowId = instance.getDataAtRowProp(visualRow + 1, 'id');

  return rowId !== nextRowId;
}
